// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1f3eI","ranges":"BmiRanges_ranges__1qSBy"};